import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Flame, Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { label: "Home", path: "/" },
  { label: "Live Rates", path: "/rates" },
];

export const Header = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const dashPath = user && user.role === "admin" ? "/travisb-admin" : "/dashboard";

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A1026]/90 backdrop-blur-xl border-b border-blue-900/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="w-9 h-9 rounded-xl flex items-center justify-center tb-btn-primary">
            <span className="font-head font-extrabold text-white text-lg">T</span>
          </span>
          <span className="font-head font-extrabold text-lg sm:text-xl text-white">
            Travis<span className="tb-gradient-text">B</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-gray-300 hover:text-blue-300 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link
                to={dashPath}
                data-testid="nav-dashboard-button"
                className="text-sm font-semibold text-blue-200 hover:text-white transition-colors"
              >
                Dashboard
              </Link>
              <button
                data-testid="nav-logout-button"
                onClick={() => {
                  logout();
                  nav("/");
                }}
                className="px-4 py-2 rounded-full text-sm font-semibold border border-blue-500/40 text-white hover:bg-blue-500/10 transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-button"
                className="text-sm font-semibold text-gray-200 hover:text-white transition-colors"
              >
                Login
              </Link>
              <Link
                to="/signup"
                data-testid="nav-signup-button"
                className="px-5 py-2.5 rounded-full text-sm font-semibold tb-btn-primary"
              >
                Get Started
              </Link>
            </>
          )}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-blue-900/30 bg-[#0A1026] px-4 py-4 space-y-3">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              onClick={() => setOpen(false)}
              className="block text-gray-200 font-medium py-1"
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </Link>
          ))}
          <div className="pt-2 flex gap-3">
            {user ? (
              <>
                <Link to={dashPath} onClick={() => setOpen(false)} className="flex-1 text-center px-4 py-2 rounded-full tb-btn-primary text-sm font-semibold">
                  Dashboard
                </Link>
                <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="flex-1 px-4 py-2 rounded-full border border-blue-500/40 text-sm font-semibold">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="flex-1 text-center px-4 py-2 rounded-full border border-blue-500/40 text-sm font-semibold">
                  Login
                </Link>
                <Link to="/signup" onClick={() => setOpen(false)} className="flex-1 text-center px-4 py-2 rounded-full tb-btn-primary text-sm font-semibold">
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
